/**
 * Строка партии таблицы планов: галочка и ячейки TanStack. Вынесено из
 * `components/PlansTable.tsx` (нарезка 14.10.26).
 */

import { flexRender, type useReactTable } from "@tanstack/react-table";
import type { PlanRow } from "@/lib/providers";
import { PickBox } from "./PickBox";
import { TAIL, W } from "./style";

export function PlanRowView({
  row,
  open,
  picked,
  onPick,
  table,
  onToggle,
  onStatus,
}: {
  row: PlanRow;
  open: boolean;
  picked: boolean;
  onPick: (on: boolean) => void;
  table: ReturnType<typeof useReactTable<PlanRow>>;
  onToggle: () => void;
  /** Клик по статусу партии — панель «Активный ↔ Отмена»; нет — статус надписью
   *  («Отгружен» ставит крон areserv, а «только смотреть» не правит). */
  onStatus?: (() => void) | undefined;
}) {
  const tableRow = table.getRowModel().rowsById[String(row.id)];
  const cells = tableRow?.getVisibleCells() ?? [];
  return (
    <div
      onClick={onToggle}
      className={
        "flex h-[var(--spacing-row)] w-full cursor-pointer items-center border-b border-border text-[13px] hover:bg-bg-hover " +
        (open || picked ? "bg-bg-hover" : "")
      }
    >
      <PickBox
        state={picked ? "all" : "none"}
        title="отметить партию"
        onChange={onPick}
      />
      {cells.map((cell) => (
        <div
          key={cell.id}
          className={"px-2.5 " + (W[cell.column.id] ?? "w-[100px]")}
        >
          {cell.column.id === "status" && onStatus ? (
            // Клик по статусу не сворачивает строку: он открывает свою панель.
            <button
              type="button"
              title="сменить статус партии — запись в areserv"
              onClick={(event) => {
                event.stopPropagation();
                onStatus();
              }}
              className="cursor-pointer rounded-full hover:ring-1 hover:ring-accent"
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </button>
          ) : (
            flexRender(cell.column.columnDef.cell, cell.getContext())
          )}
        </div>
      ))}
      <div className={TAIL} />
    </div>
  );
}
